const CC_DELETE_CONFIRMATION =
  'Are you sure you want to delete the payment method ending with';

const NO_INVOICE_MESSAGE =
  'Invoice information is not available at this moment, please try later.';

const DEFAULT_ERROR_MESSAGE = 'There was an error please try later';

const CHARGE_SUCCESS_MESSAGE = 'Charge Succeeded';

const ADD_PAYMENT_ERROR_MESSAGE =
  'Your payment method was not added, please contact support if you need assistance.';

const MAKE_PAYMENT_ERROR_MESSAGE =
  'Your payment was not processed, please contact support if you need assistance.';

const INVOICE_FILE_NOT_AVAILABLE = 'Invoice file not available';

const PRIMARY_BILLING_LABEL = ' (Your Primary Billing Site)';

export {
  ADD_PAYMENT_ERROR_MESSAGE,
  CC_DELETE_CONFIRMATION,
  CHARGE_SUCCESS_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  INVOICE_FILE_NOT_AVAILABLE,
  MAKE_PAYMENT_ERROR_MESSAGE,
  NO_INVOICE_MESSAGE,
  PRIMARY_BILLING_LABEL,
};
